import { Component, Panel, PanelProps } from "@mcleod/components";
import { numCols, numRows } from "./HomePageUtil";

export class HomePageEditorGrid extends Panel {
  gridDot: Panel[][] = [];
  constructor(props: Partial<PanelProps>) {
    super({ ...props });
    for (let x = 0; x < numCols; x++) {
      this.gridDot[x] = [];
      for (let y = 0; y < numRows; y++) {
        const dot = new Panel({ id: "gridPointPanel", borderRadius: "50%", backgroundColor: "primary.darker", padding: 2, zIndex: -1, style: { position: "absolute" } });
        dot.left = "calc(" + (x * (100 / numCols)) + "% - 2px)";
        dot.top = "calc(" + (y * (100 / numRows)) + "% - 2px)";
        this.gridDot[x][y] = dot;
        this.add(dot);
      }
    }
  }

  override add(...components: Component[]): Component {
    for (const comp of components) {
      this._element.appendChild(comp._element);
      this._components.push(comp);
    }
    return components?.length > 0 ? components[0] : null;
  }
}
